module.exports = __webpack_public_path__ + "static/github-dependabot-b1814a936b855cc26453cf61b71d5444.png";